import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
function EmbeddedBrowser({ url }) {
  const [proxyUrl, setProxyUrl] = useState(null);

  useEffect(() => {
    fetch(
      "https://secret-sierra-62981.herokuapp.com/https://thybdnbrcn3pin6jmavqbzgbgq0arabj.lambda-url.us-east-1.on.aws/",
      {
        headers: {
          Origin: window.location.origin, // Pretend it's from your frontend
          "X-Requested-With": "XMLHttpRequest", // Optional, but helps with CORS
        },
      },
    )
      .then((response) => response.text()) // Assuming it's returning a URL as plain text
      .then((redirectUrl) => {
        console.log("Redirected URL:", redirectUrl);

        const fullProxyUrl =
          "https://secret-sierra-62981.herokuapp.com/" + redirectUrl;
        setProxyUrl(fullProxyUrl);
      })
      .catch((err) => console.error("Error fetching redirect:", err));
  }, []);

  return proxyUrl ? (
    <iframe
      src={proxyUrl}
      title="Embedded Browser"
      style={{ width: "100%", height: "100vh", border: "none" }}
    />
  ) : (
    <div>Loading...</div>
  );
}

EmbeddedBrowser.propTypes = {
  url: PropTypes.string.isRequired,
};

export default EmbeddedBrowser;

EmbeddedBrowser.propTypes = {
  url: PropTypes.string,
};
